import { toast } from "react-toastify";
import URLS from "../services/URLS";
import {
  EXPORT_REPORTED_CSV,
  EXPORT_SERVICE_PROVIDER_CSV,
  EXPORT_USER_CSV,
} from "../services/ApiCalls";
import { accountType, statusEnum } from "./const";

export const changePageToOne = (body, setBody) => {
  const newBody = { ...body, page: 1 };
  setBody((p) => newBody);
  return newBody;
};

export const changeBody = (body, setBody, key, value) => {
  const newBody = {
    ...body,
    [key]: value,
  };
  setBody((p) => newBody);
  return newBody;
};

export const AdminStatusOptionSubscription = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "In Active",
    value: "inactive",
  },
];

export const capitalizedFirstAlphaBet = (value) => {
  if (!value || typeof value !== "string") return;
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const removeUnderScoreAndCapitalizeFirstLetter = (value) => {
  if (!value || typeof value !== "string") return;
  const formattedString = value.replace(/_/g, " ").toLowerCase();

  return capitalizedFirstAlphaBet(formattedString);
};

export const makingOptionsFromArr = (arr) => {
  return arr.map((type) => ({
    label: removeUnderScoreAndCapitalizeFirstLetter(type), // Remove underscores and capitalize first letters
    value: type,
  }));
};

export const makingOptionsFromData = (arr, labelKey, valueKey) => {
  return arr.map((item) => ({
    label: removeUnderScoreAndCapitalizeFirstLetter(item[labelKey]), // Remove underscores and capitalize first letters
    value: item[valueKey],
  }));
};

export const removeUnderScore = (message) => {
  if (!message || typeof message !== "string") {
    toast.dismiss();

    return toast.warning("something went wrong");
  }

  return message.split("_").join(" ");
};

export function createObjectURL(object) {
  return window.URL
    ? window.URL.createObjectURL(object)
    : window.webkitURL.createObjectURL(object);
}

export const exportCsvHandler = async (data, setLoader,body) => {
  try {
    setLoader && setLoader(true);
    let res;
    if (data === "users") {
      res = await EXPORT_USER_CSV();
    }
    if (data === "service-providers") {
      res = await EXPORT_SERVICE_PROVIDER_CSV();
    }
    // if (data === "properties") {
    //   res = await EXPORT_PROPERTY_CSV();
    // }

    if (data === "dispute") {
      res = await EXPORT_DISPUTE_CSV();
    }
    if(data==="reported")
    {
      res=await EXPORT_REPORTED_CSV(body);
    }

    data = data == "service-providers" ? "experts" : data;

    if (res.status === 200) {
      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(res.data);
      hiddenElement.target = "_blank";
      hiddenElement.download = `${data} Report.csv`;
      hiddenElement.click();
      setLoader && setLoader(false);
    } else {
      setLoader && setLoader(false);
      toast.error("something went wrong");
    }
  } catch (error) {
    setLoader && setLoader(false);
    toast.error("something went wrong");
  }
};

export const catchAsync = (fn, setLoader, callBack) => {
  return (...arg) =>
    fn(...arg).catch((error) => {
      toast.dismiss();
      toast.error("something went wrong");
      setLoader && setLoader(false);
      callBack && callBack();
      console.log(error, "error");
    });
};

export const checkResponse = ({
  res,
  setData,
  setTotal,
  showSuccess,
  dataToSet,
  setLoader,
  totalCount,
}) => {
  if (res?.data?.status === "success") {
    setData && setData(dataToSet || res?.data?.data);
    setTotal && setTotal(totalCount || res?.data?.totalcount);
    showSuccess && (toast.dismiss(), toast.success(res?.data?.message));
    setLoader && setLoader(false);
    return true;
  } else {
    toast.dismiss();
    toast.error(res?.data?.message);
    setLoader && setLoader(false);
    return false;
  }
};

export function getLast7Days() {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dates = [];
  for (let i = 1; i <= 7; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const day = date.getDate();
    const month = months[date.getMonth()];
    dates.push(`${day} ${month}`);
  }

  return dates.reverse();
}

export const findLabelOfStatus = (val) => {
  if (!val) return val;
  if (typeof val === "object") return "";
  const statusObject = Object.values(statusEnum).find(
    (status) => status.value === val
  );
  return statusObject ? statusObject?.label : val;
};

export const findLabelOfAccountType = (val) => {
  if (!val) return val;
  if (typeof val === "object") return "";
  const accountTypeEnum = Object.values(accountType).find(
    (status) => status.value === val
  );
  return accountTypeEnum ? accountTypeEnum?.label : val;
};
